import React from "react";
import { Target, Flag, Gauge, Award } from "lucide-react";

const ITEMS = [
  { icon: Target, t: "الهدف (Objective)", d: "طموح واضح ومُلهم يصف النتيجة التي تريدها خلال الدورة." },
  { icon: Flag, t: "النتائج الرئيسية (Key Results)", d: "٢–٣ نتائج قابلة للتحقق برقم ومدة — تجيب: كيف نعرف أننا وصلنا؟" },
  { icon: Gauge, t: "مؤشرات الأداء (KPIs)", d: "أرقام نتابعها باستمرار لنعدّل التنفيذ قبل نهاية الدورة." },
];

export function GoalsMethodCard() {
  return (
    <div className="glass rounded-2xl p-5 border border-primary/20" data-testid="goals-method-card">
      <div className="flex items-center gap-2 mb-3">
        <Award className="w-5 h-5 text-accent" />
        <h2 className="font-bold text-base md:text-lg">نطبّق منهجية OKR + KPI كأفضل الممارسات العالمية</h2>
      </div>
      <p className="text-sm text-muted-foreground mb-4 leading-relaxed">
        المنهجية التي تدير بها كبرى الشركات أهدافها: هدف طموح، نتائج رئيسية قابلة للتحقق، ومؤشرات أداء نراقبها لنصل إلى نتيجة مفيدة وذات قيمة.
        راجع ما يقترحه الذكاء الاصطناعي، عدّل الأرقام بما يناسبك، ثم <b>اعتمد</b> لتنتقل إلى التنفيذ.
      </p>
      <div className="grid gap-3 sm:grid-cols-3">
        {ITEMS.map((it) => (
          <div key={it.t} className="rounded-xl border border-border bg-secondary/60 p-3" data-testid="goals-method-item">
            <div className="flex items-center gap-2 font-bold text-sm mb-1"><it.icon className="w-4 h-4 text-primary" /> {it.t}</div>
            <p className="text-xs text-muted-foreground leading-relaxed">{it.d}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
